import React, { Component } from 'react';
import styled from 'styled-components';
import { getLove, getTimeToDate } from '../utils';

const dateMet = 'August 28, 2022';
const dateStarted = 'September 10, 2022';
const weddingDate = 'December 13, 2025';

const Container = styled.div`
  background-color: var(--favorite1);
  color: white;

  display: flex;
  flex-flow: column;
  position: absolute;
  height: 100%;
  width: 100%;
  text-align: center;
`;

const Text = styled.div`
  text-align: center;
  margin: auto;
`;

class Love extends Component {
  render() {
    const alreadyMarried = new Date(weddingDate) < new Date();

    return (
      <Container>
        <Text>
          <h1 className="Text">Llevamos juntos</h1>
          <h1 className="Text">{getLove(dateStarted)}</h1>
          <h1 className="Text">🙌🏽🤍🥳</h1>
        </Text>

        <Text>
          <h1 className="Text">{alreadyMarried ? '' : 'Nos casamos en'}</h1>
          <h1 className="Text">{getTimeToDate(weddingDate)}</h1>
          <h1 className="Text">{alreadyMarried ? 'casados!! ' : ''}💍</h1>
        </Text>
      </Container>
    );
  }
}

export default Love;
